import axios from "infra/http";
import { useMutation } from "react-query";
import { showError, showSuccess } from "infra/helpers/alerta";
import error from "core/resources/firebase/error";
import { queryClient } from "infra/packages/react-query";
import { ConfirmarDadosPortariaForm } from "core/features/portaria/typings";

function useConfirmarAutorizacaoPortaria(
  onClose?: () => any,
  onConfirm?: () => any
) {
  return useMutation(
    ({ id, body }: { id: string; body?: ConfirmarDadosPortariaForm }) => {
      if (body) {
        const formData = new FormData();

        body.pessoaId && formData.append("pessoaId", body.pessoaId);
        body.nome && formData.append("nome", body.nome);
        body.documento && formData.append("documento", body.documento);
        body.arquivoFoto && formData.append("arquivoFoto", body.arquivoFoto);
        body.arquivoDocumento &&
          formData.append("arquivoDocumento", body.arquivoDocumento);
        body.placa && formData.append("placa", body.placa);
        body.cnh && formData.append("cnh", body.cnh);

        return axios.post(`/v1/portaria/${id}/confirmar`, formData);
      }

      return axios.post(`/v1/portaria/${id}/confirmar`);
    },
    {
      onError(err: any) {
        showError(error[(err as any).code]);
      },
      onSuccess(_, id) {
        showSuccess("Autorização de portaria confirmada com sucesso!").then(
          () => {
            onClose?.();
            onConfirm?.();
          }
        );

        queryClient.setQueryData(["/portaria", id], (data: any) => {
          return {
            ...data,
            status: "confirmado",
          };
        });
      },
    }
  );
}

export default useConfirmarAutorizacaoPortaria;
